import gold from "@cs/public/img/olympiad/cso21_photos/gold.png";
import silver from "@cs/public/img/olympiad/cso21_photos/silver.png";
import bronze from "@cs/public/img/olympiad/cso21_photos/bronze.png";

import eleonore from "@cs/public/img/olympiad/cso21_photos/eleonore.png"
import alexandra from "@cs/public/img/olympiad/cso21_photos/alexandra.png"

export const WINNERS = {
  gold: {
    icon: gold,
    expand: true,
    participants: [
      {
        img: eleonore,
        name: "quotes.eleonore.name",
        info: "quotes.eleonore.14-uk",
        quote: "quotes.eleonore.quote"
      },
      {
        img: alexandra,
        name: "quotes.alexandra.name",
        info: "quotes.alexandra.14-uk",
        quote: "quotes.alexandra.quote"
      },
    ]
  },
  silver: {
    icon: silver,
    expand: false,
    participants: [
      {
        img: silver,
        name: "cso21.winners-silver-name-1",
        info: "cso21.winners-silver-info-1"
      },
      {
        img: silver,
        name: "cso21.winners-silver-name-2",
        info: "cso21.winners-silver-info-2"
      },
    ]
  },
  bronze: {
    icon: bronze,
    expand: false,
    participants: [
      {
        img: bronze,
        name: "cso21.winners-bronze-name-1",
        info: "cso21.winners-bronze-info-1"
      },
      {
        img: bronze,
        name: "cso21.winners-bronze-name-2",
        info: "cso21.winners-bronze-info-2"
      },
    ]
  }
}